import React from 'react';
import PropTypes from 'prop-types';
import './NotFound.scss';

function NotFound({
  root, logoUrl, notFoundUrl, backdropUrl, explanation,
}) {
  return (
    <div>
      <div className="backdrop-div">
        <img src={backdropUrl} alt="" />
      </div>
      <div className="backdrop-div not-found-container">
        <div className="panel panel-default not-found-panel">
          <div className="panel-content">
            <img src={logoUrl} className="logo-image" alt="" />
            <img src={notFoundUrl} className="not-found-image" alt="" />
            <div className="ooops-div">
              Ooops
            </div>
            <div className="divider" />
            <div className="explanation-div">
              {explanation}
            </div>
            <a className="btn btn-primary" href={root}>
              Take Me Home
              <div className="glyphicon glyphicon-menu-right" />
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}

NotFound.propTypes = {
  root: PropTypes.string.isRequired,
  logoUrl: PropTypes.string.isRequired,
  notFoundUrl: PropTypes.string.isRequired,
  backdropUrl: PropTypes.string.isRequired,
  explanation: PropTypes.string.isRequired,
};

export default NotFound;
